import type { Resource } from '../../';
export const country_countries_TN: Resource = {"default":"Tunisia"};
